import {
  Facebook,
  Instagram,
  Twitter,
  Youtube,
  MessageCircleMore,
} from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";

export default function MainFooter({settings}) {

  return (
    <section className="bg-gradient-to-t from-blue-800 to-blue-500 mt-20">
      <div className="space-y-10 max-w-7xl mx-auto px-4 pt-20 pb-10 text-white">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Links */}
          <div>
            <h3 className="text-xl font-bold mb-4">روابط</h3>
            <ul className="space-y-2">
              <li>
                <Link href="#" className="hover:underline text-white/80">
                  من نحن
                </Link>
              </li>
              <li>
                <Link href="#" className="hover:underline text-white/80">
                  الدورات التعليمية
                </Link>
              </li>
              <li>
                <Link href="#" className="hover:underline text-white/80">
                  المقالات
                </Link>
              </li>
              <li>
                <Link href="#" className="hover:underline text-white/80">
                  إرشادات وكيفية
                </Link>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h3 className="text-xl font-bold mb-4">الأقسام</h3>
            <ul className="space-y-2">
              <li>
                <Link href="#" className="hover:underline text-white/80">
                  لغة عربية
                </Link>
              </li>
              <li>
                <Link href="#" className="hover:underline text-white/80">
                  قرآن كريم
                </Link>
              </li>
              <li>
                <Link href="#" className="hover:underline text-white/80">
                  برمجة
                </Link>
              </li>
            </ul>
          </div>

          {/* Latest Articles */}
          <div className="col-span-2 lg:col-span-1">
            <h3 className="text-xl font-bold mb-4">أحدث المقالات</h3>
            <ul className="space-y-2">
              <li>
                <Link href="#" className="hover:underline text-white/80">
                  كيفية تحسين مهارات التصميم لديك
                </Link>
              </li>
              <li>
                <Link href="#" className="hover:underline text-white/80">
                  اهم مهارات التصميم في 2025
                </Link>
              </li>
            </ul>
          </div>

          {/* Logo and social media section */}
          <div className="flex flex-col items-center md:items-start col-span-2 lg:col-span-1">
            <div className="flex flex-col items-center">
              <div className="bg-blue-500 rounded-full p-3 w-16 h-16 flex items-center justify-center mb-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="w-8 h-8"
                >
                  <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
                  <path d="M6 12v5c0 2 2 3 6 3s6-1 6-3v-5" />
                </svg>
              </div>
              <h2 className="text-lg font-bold mb-4">علي أكاديمي</h2>
            </div>
            <div className="flex gap-4 space-x-reverse mt-2">
              <Link href={settings.whatsapp_site} aria-label="WhatsApp">
                <MessageCircleMore className="w-5 h-5" />
              </Link>
              <Link href={settings.facebook_site} aria-label="Facebook">
                <Facebook className="w-5 h-5" />
              </Link>
              <Link href={settings.instagram_site} aria-label="Instagram">
                <Instagram className="w-5 h-5" />
              </Link>
              <Link href={settings.twitter_site} aria-label="Twitter">
                <Twitter className="w-5 h-5" />
              </Link>
              <Link href={settings.youtube_site} aria-label="YouTube">
                <Youtube className="w-5 h-5" />
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom footer */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-2">
          <div className="text-sm font-bold">علي أكاديمي</div>
          <div className="flex flex-wrap justify-center md:justify-start gap-4 mb-4 md:mb-0">
            <Link href="#" className="text-sm hover:underline text-white/80">
              شروط الخدمة
            </Link>
            <Link href="#" className="text-sm hover:underline text-white/80">
              سياسة الخصوصية
            </Link>
            <Link href="#" className="text-sm hover:underline text-white/80">
              الأمان
            </Link>
            <Link href="#" className="text-sm hover:underline text-white/80">
              خريطة الموقع
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
